/*eslint-disable*/
import React from "react";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import FormDropdown from "components/Wrappers/materialUIWrappers/components/FormDropDown";
import DatePicker from "components/Wrappers/materialUIWrappers/components/DatePicker";
import { Field } from "redux-form";
import {
  Grid,
  FormControl,
  Card,
  CardContent,
  CardHeader,
  withStyles
} from "@material-ui/core";

const required = value => (value ? undefined : "Required");

const requiredDropdown = value => {
  if (value === "validationError") {
    return "Required";
  } else if (value) {
    return undefined;
  } else {
    return "Required";
  }
};

const styles = () => ({});

class CC_bankDetail extends React.Component {
  componentDidMount(){
    this.props.scrollMeBar();
  }
  
  render() {
    const validate = [];
    validate.push(required);

    return (
      <Card className="contentWithStepper">
        <CardHeader title="Client Bank Details" />
        <CardContent>
          <Grid container spacing={24}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Field
                  name={"bankAccountName"}
                  component={FormInput}
                  label={"Account name"}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Field
                  component={FormDropdown}
                  checkValidation={this.props.checkValidation}
                  label="Bank"
                  name="bank"
                  options={[
                    {
                      value: "validationError",
                      displayValue: "Please select"
                    },
                    { value: "absa", displayValue: "Absa" },
                    { value: "fnb", displayValue: "FNB"},
                    { value: "capitec", displayValue: "Capitec"},
                    { value: "nedbank", displayValue: "Nedbank"},
                    { value: "standardbank", displayValue: "Standard Bank"},
                    { value: "africanbank", displayValue: "African Bank"},
                    { value: "mercantilebank", displayValue: "Mercantile Bank"},
                    { value: "grindrodbank", displayValue: "Grindrod Bank"},
                    { value: "bidvestbank", displayValue: "Bidvest Bank"},
                    { value: "sasfin", displayValue: "Sasfin"},
                    { value: "albarakabank", displayValue: "Albaraka Bank"},
                    { value: "ubank", displayValue: "Ubank"},
                    { value: "hbzbank", displayValue: "HBZ Bank"},
                    { value: "southafricanbankofathens", displayValue: "South African Bank of Athens"},
                    { value: "discoverybank", displayValue: "Discovery Bank"},
                  ]}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Field
                  name={"bankBranch"}
                  component={FormInput}
                  label={"Branch"}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Field
                  name={"bankBranchCode"}
                  component={FormInput}
                  label={"Branch code"}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Field
                  name={"bankAccNumber"}
                  component={FormInput}
                  label={"Account number"}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Field
                  name={"bankAccountType"}
                  component={FormInput}
                  label={"Type of account"}
                />
              </FormControl>
            </Grid>

          </Grid>
        </CardContent>
      </Card>
    );
  }
}

export default withStyles(styles)(CC_bankDetail);



// WEBPACK FOOTER //
// ./src/views/Clients/components/CC_bankDetail.jsx